import { render } from "./LanguageSheetContent.vue?vue&type=template&id=47221290&scoped=true"
import script from "./LanguageSheetContent.vue?vue&type=script&lang=js"
export * from "./LanguageSheetContent.vue?vue&type=script&lang=js"

import "./LanguageSheetContent.vue?vue&type=style&index=0&id=47221290&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47221290"]])

export default __exports__